import React from 'react';
import { Tooltip, TooltipContent, TooltipTrigger } from 'shadcn-ui';
import { TooltipIconLayoutProps } from '../types';
import { IconButton, IconType } from '../../IconButton';

export default function ShadcnTooltipIconLayout(
  props: TooltipIconLayoutProps
) {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span className="inline-block ml-2 relative -top-px">
          <IconButton onClick={() => { /* noop - tooltip handles interaction */ }} type={IconType.HELP} />
        </span>
      </TooltipTrigger>
      <TooltipContent side="bottom" className="max-w-xs p-4 text-sm">
        {props.tooltipContent}
      </TooltipContent>
    </Tooltip>
  );
}
